import { GeneratePinResponseDTO } from '@/core/dto/psychosocial-report';
import { GeneratePinResponse } from '@/types/Psychosocial';

export class GeneratePinMapper {
	constructor(private readonly data: GeneratePinResponseDTO) {}

	public toDomain(): GeneratePinResponse {
		return {
			status: this.data.status,
			message: this.data.message,
			pin: this.data.pin
		};
	}
}
